module.exports = __webpack_public_path__ + "img/corner-right-down.3c1b0f1f.svg";